/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useCallback } from 'react';
import { SearchLocationInputProps } from './types';
import InputText from '../common/InputText';
import styles from './SearchLocationInput.module.scss'

const SearchLocationInput = ({
  id,
  name,
  label,
  searchType,
  onSelectLocation,
  onChange,
  onBlur,
  value,
  errorMsg,
  isValid = true,
}: SearchLocationInputProps ) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const autoCompleteRef = useRef<google.maps.places.Autocomplete | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const handlePlaceSelect = useCallback(() => {
    const addressObject = autoCompleteRef?.current?.getPlace();
    if (addressObject && addressObject.address_components) {
      onSelectLocation(addressObject?.address_components);
    }
  }, [onSelectLocation]);

  const handleScriptLoad = useCallback(() => {
    if (!autoCompleteRef.current) {
      autoCompleteRef.current = new window.google.maps.places.Autocomplete(
        (inputRef?.current as HTMLInputElement),
        {
          componentRestrictions: { country: 'us' },
          types: [searchType],
        },
      );
      autoCompleteRef?.current?.setFields([
        'address_components',
        'formatted_address',
      ]);
      autoCompleteRef?.current?.addListener('place_changed', handlePlaceSelect);
    }
  }, [handlePlaceSelect, searchType]);

  const setAutocomplete = useCallback(() => {
    if (id === 'shipping-streetAddress') {
      const pacContainer = document.getElementsByClassName('pac-container');
      containerRef?.current?.append(pacContainer[0]);
      document?.getElementById(id)?.setAttribute('autocomplete', 'autocomplete-off');
    }
  }, [id]);

  useEffect(() => {
    const currentRef = containerRef?.current;
    if (containerRef?.current && window.google) {
      containerRef.current.addEventListener('focusin', setAutocomplete);
      handleScriptLoad();
    }
    return () => {
      if (currentRef) {
        currentRef.removeEventListener('focusin', setAutocomplete);
      }
    };
    // eslint-disable-next-line
  }, [handleScriptLoad, setAutocomplete, window.google]);    

  return (
    <div ref={containerRef} className={styles.container}>
      <InputText
        placeholder=""
        ref={inputRef}
        name={name}
        id={id}
        onChange={onChange}
        value={value}
        label={label}
        onBlur={onBlur}
        errorMsg={errorMsg}
        isValid={isValid}
      />
    </div>
  );
};

export default SearchLocationInput;
